export var CookiePrefType;
(function (CookiePrefType) {
    CookiePrefType["FUNCTIONNAL"] = "functionnal";
    CookiePrefType["ANALYTICS"] = "analytics";
    CookiePrefType["ADVERTISING"] = "advertising";
})(CookiePrefType || (CookiePrefType = {}));
export var cookiesPrefsData = [
    {
        key: CookiePrefType.FUNCTIONNAL,
        label: 'cookie-preferences-center.data.functionnal.label',
        content: 'cookie-preferences-center.data.functionnal.content',
        hasSwitch: true,
        active: false,
        switchDefaultValue: true,
    },
    {
        key: CookiePrefType.ANALYTICS,
        label: 'cookie-preferences-center.data.analytics.label',
        content: 'cookie-preferences-center.data.analytics.content',
        hasSwitch: true,
        active: true,
        switchDefaultValue: false,
    },
    {
        key: CookiePrefType.ADVERTISING,
        label: 'cookie-preferences-center.data.advertising.label',
        content: 'cookie-preferences-center.data.advertising.content',
        hasSwitch: false,
    },
];
